if (!customElements.get('volume-discount-selector')) {
  customElements.define(
    'volume-discount-selector',
    class VolumeDiscountSelector extends HTMLElement {
      connectedCallback() {
        this.quantityInput = document.getElementById(this.dataset.inputId);
        if (!this.quantityInput) return;

        this.buttons = Array.from(this.querySelectorAll('[data-volume-quantity]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.select(button));
        });
        this.quantityInput.addEventListener('input', () => this.sync());
        this.quantityInput.addEventListener('change', () => this.sync());
        this.sync();
      }

      select(button) {
        const quantity = Number(button.dataset.volumeQuantity);
        const minimum = Number(this.quantityInput.min || 1);
        const maximum = Number(this.quantityInput.max || Infinity);
        if (!Number.isFinite(quantity) || quantity < minimum || quantity > maximum) return;

        this.quantityInput.value = String(quantity);
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }

      sync() {
        const value = Number(this.quantityInput.value);
        this.buttons.forEach((button) => {
          const selected = Number(button.dataset.volumeQuantity) === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      }
    },
  );
}
